import React, { useEffect, useState } from "react";
import Tooltip, { TooltipProps } from "@mui/material/Tooltip";
import { PopperProps } from "@mui/material/Popper";

interface TooltipBestViewProps extends Omit<TooltipProps, "PopperProps"> {
    slotProps?: {
        popper?: Partial<PopperProps>;
    };
    offsetY?: number;
    open?: boolean;
    setOpen?: any;
    
}

const TooltipBestView: React.FC<TooltipBestViewProps> = ({
    slotProps,
    offsetY,
    open,
    setOpen,
    ...props
}) => {
  const _offsetY = offsetY === undefined ? -20 : offsetY;
  const [tooltipOpen, setTooltipOpen] = useState<boolean>(open!==undefined ? open : false);

  const handleTooltipClose = () => {
     (setOpen!==undefined) ?  setOpen(false) : setTooltipOpen(false);
      
     
  };

  const handleTooltipOpen = () => {
      setOpen !== undefined ? setOpen(true) : setTooltipOpen(true);
      
  };

  useEffect(() => {
    if (open!==undefined) 
        {
            setTooltipOpen(open);
        }
  }, [open]);
  
  
    return (
        <Tooltip
            open={tooltipOpen}
            onClose={handleTooltipClose}
            onOpen={handleTooltipOpen}
            {...props}
            PopperProps={{
                ...slotProps?.popper,
                modifiers: [
                    {
                        name: "offset",
                        options: {
                            offset: [0, _offsetY],
                        },
                    },
                    ...(slotProps?.popper?.modifiers || []),
                ],
            }}
        />
    );
};

export default TooltipBestView;
